export const targetedDistributionVoucherLabels = {
  TARGETED: 'Targeted',
  PUBLIC: 'Public',
};
